import React from 'react'
import { Card, Typography, Grid, Box } from '../utils/AllImportsHelper'
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import NotificationPage from '../component/CommonPage/NotificationPage';

const Settings = () => {
  const [value, setValue] = React.useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box>
      <Box><Typography variant="subtitle1" fontWeight={500} pb={1}>
        Setting
      </Typography></Box>
      <Card>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleChange} aria-label="lab API tabs example">
              <Tab label="Notification Settings" value="1" />
            </TabList>
          </Box>
          <TabPanel value="1" sx={{ p: '1rem !important' }}>
            <NotificationPage />
          </TabPanel>
        </TabContext>
      </Card>
    </Box>
  )
}

export default Settings